import Vue from 'vue';
import { JUMP_LOGIC_PATHS, JUMP_ACTIONS } from '@/consts/jumpLogic';
import { QUESTION_TYPE } from '@/consts/survey';
import * as types from './mutationTypes';

export default {
  [types.SET_SURVEY_UUID](state, { uuid }) {
    state.survey.uuid = uuid;
  },
  [types.SET_SURVEYS](state, { surveys }) {
    state.surveys = surveys;
  },
  [types.CLEAR_SURVEYS](state) {
    state.surveys = null;
  },
  [types.CLEAR_SURVEY](state) {
    state.survey = null;
  },
  [types.SET_INTEGRATIONS](state, integrations) {
    state.integrations = integrations;
  },
  [types.CLEAR_INTEGRATIONS](state) {
    state.integrations = [];
  },
  [types.SET_INTEGRATION](state, integrationUUID) {
    state.survey.zendesk_integration_uuid = integrationUUID;
  },
  [types.SET_QUERY_PARAMS](state, { params }) {
    state.queryParams = {
      ...state.queryParams,
      ...params,
    };
  },
  [types.CLEAR_QUERY_PARAMS](state) {
    state.queryParams = {};
  },
  [types.SET_SURVEY](state, { survey }) {
    state.survey = survey;
  },
  [types.SET_TEAMS_PERMISSION](state, { teamsPermission }) {
    state.teamsPermission = teamsPermission || [];
  },
  [types.SET_CATEGORIES](state, { categories }) {
    state.categories = categories || [];
  },
  [types.CLEAR_TEAMS_PERMISSION](state) {
    state.teamsPermission = [];
  },
  [types.CLEAR_CATEGORIES](state) {
    state.categories = [];
  },
  [types.SET_USER_TEAMS](state, { userTeams }) {
    state.userTeams = userTeams;
  },
  [types.CLEAR_USER_TEAMS](state) {
    state.userTeams = [];
  },
  [types.CLEAR_SURVEY_ITEM_CHILDREN](state, { surveyItemIndex }) {
    state.survey.items[surveyItemIndex].items = [];
  },
  [types.UPDATE_SURVEY_ITEM](state, { surveyItemIndex, surveyItem }) {
    Vue.set(state.survey.items, surveyItemIndex, surveyItem);
  },
  [types.ADD_SURVEY_ITEM](state, { item }) {
    state.survey = {
      ...state.survey,
      items: [...(state.survey?.items || []), item],
    };
  },
  [types.SET_SELECTED_SURVEY_ITEM_INDEX](state, { index }) {
    state.selectedSurveyItemIndex = index;
  },
  [types.CLEAR_SELECTED_SURVEY_ITEM_INDEX](state) {
    state.selectedSurveyItemIndex = null;
  },
  [types.SET_NAME](state, { name }) {
    state.survey.name = name;
  },
  [types.SET_STATUS](state, { status }) {
    state.survey.status = status;
  },
  [types.SET_SURVEY_ITEM](state, { index, item }) {
    state.survey.items[index].type = item.type;
    state.survey.items[index].question = item.question;
  },
  [types.SET_SURVEY_ITEM_QUESTION](state, { question, language, index }) {
    state.survey.items[index].question[language] = question;
  },
  [types.SET_SURVEY_ITEM_COMMENTS_ENABLED](state, { value, index }) {
    state.survey.items[index].comments_enabled = value;
  },
  [types.SET_SURVEY_ITEM_DETRACTOR_COMMENT](state, { question, language, index }) {
    state.survey.items[index].detractor_comment_question[language] = question;
  },
  [types.SET_SURVEY_ITEM_NEUTRAL_COMMENT](state, { question, language, index }) {
    state.survey.items[index].neutral_comment_question[language] = question;
  },
  [types.SET_SURVEY_ITEM_PROMOTER_COMMENT](state, { question, language, index }) {
    state.survey.items[index].promoter_comment_question[language] = question;
  },
  [types.SET_SURVEY_ITEM_BUTTON_DESIGN](state, { design, index }) {
    state.survey.items[index].button_design = design;
  },
  [types.SET_SURVEY_ITEM_INVERTED_SCALE](state, { scale, index }) {
    state.survey.items[index].inverted_scale = scale;
  },
  [types.SET_SURVEY_ITEM_OBLIGATORY](state, { isObligatory, index }) {
    state.survey.items[index].is_obligatory = isObligatory;
  },
  [types.SET_SURVEY_ITEM_OBLIGATORY_DETRACTOR](state, { isObligatory, index }) {
    state.survey.items[index].is_obligatory_detractor = isObligatory;
  },
  [types.SET_SURVEY_ITEM_OBLIGATORY_NEUTER](state, { isObligatory, index }) {
    state.survey.items[index].is_obligatory_neuter = isObligatory;
  },
  [types.SET_SURVEY_ITEM_OBLIGATORY_PROMOTOR](state, { isObligatory, index }) {
    state.survey.items[index].is_obligatory_promotor = isObligatory;
  },
  [types.SET_SURVEY_ITEM_COLOR_PATTERN](state, { pattern, index }) {
    state.survey.items[index].color_pattern = pattern;
  },
  [types.SET_SURVEY_ITEM_CUSTOM_COLOR](state, { color, index }) {
    state.survey.items[index].custom_color = color;
  },
  [types.SET_SURVEY_ITEM_COMMENT_QUESTION](state, { question, language, index }) {
    state.survey.items[index].comment_question[language] = question;
  },
  [types.SET_SURVEY_ITEM_SCALE_TYPE](state, { type, index }) {
    state.survey.items[index].scale_type = type;
  },
  [types.SET_SURVEY_ITEM_MIN_SCALE](state, { scale, index }) {
    state.survey.items[index].min_scale = scale;
  },
  [types.SET_SURVEY_ITEM_MAX_SCALE](state, { scale, index }) {
    state.survey.items[index].max_scale = scale;
  },
  [types.SET_SURVEY_ITEM_BUTTON_SUBTITLE_MIN](state, { subtitle, language, index }) {
    if (language) state.survey.items[index].button_subtitle_min[language] = subtitle;
    else state.survey.items[index].button_subtitle_min = subtitle;
  },
  [types.SET_SURVEY_ITEM_BUTTON_SUBTITLE_MAX](state, { subtitle, language, index }) {
    if (language) state.survey.items[index].button_subtitle_max[language] = subtitle;
    else state.survey.items[index].button_subtitle_max = subtitle;
  },
  [types.SET_SURVEY_ITEM_URL](state, { url, index }) {
    state.survey.items[index].url = url;
  },
  [types.SET_SURVEY_ITEM_EXTENSION](state, { extension, index }) {
    state.survey.items[index].extension = extension;
  },
  [types.SET_SURVEY_ITEM_ALIGN](state, { align, index }) {
    state.survey.items[index].align = align;
  },
  [types.ADD_SURVEY_ITEM_OPTION](state, { option, index }) {
    state.survey.items[index].options.push(option);
  },
  [types.REMOVE_SURVEY_ITEM_OPTION](state, { optionIndex, index }) {
    state.survey.items[index].options.splice(optionIndex, 1);
  },
  [types.REMOVE_CATEGORIE_ITEM](state, { catIndex, index }) {
    state.survey.items[index].items?.splice(catIndex, 1);
  },
  [types.SET_SURVEY_ITEM_OPTION_LANGUAGE](state, {
    option, language, optionIndex, index,
  }) {
    state.survey.items[index].options[optionIndex][language] = option;
  },
  [types.SET_SURVEY_ITEM_HORIZONTAL_ALIGN](state, { align, index }) {
    state.survey.items[index].horizontal_align = align;
  },
  [types.SET_SURVEY_ITEM_OPTION_OTHER](state, { other, index }) {
    state.survey.items[index].option_other = other;
  },
  [types.SET_SURVEY_ITEM_MULTIPLE_ANSWERS](state, { multiple, index }) {
    state.survey.items[index].multiple_answers = multiple;
  },
  [types.SET_SURVEY_ITEM_RANDOMIZE](state, { randomize, index }) {
    state.survey.items[index].randomize = randomize;
  },
  [types.SET_SURVEY_ITEM_COMPOSITE_QUESTION](state, { question, language, index }) {
    state.survey.items[index].composite_question[language] = question;
  },
  [types.SET_SURVEY_ITEM_COMPOSITE_CATEGORY_LANGUAGE](state, {
    question, language, categoryIndex, index,
  }) {
    state.survey.items[index].items[categoryIndex].question[language] = question;
  },
  [types.SET_SURVEY_ITEM_COMPOSITE_SUB_CATEGORY_LANGUAGE](
    state,
    {
      question, language, categoryIndex, subCategoryIndex, index,
    },
  ) {
    state.survey.items[index].items[categoryIndex].items[subCategoryIndex].question[language] = question;
  },
  [types.SET_PRIMARY_COLOR](state, { color }) {
    state.survey.primary_color = color;
  },
  [types.SET_SECONDARY_COLOR](state, { color }) {
    state.survey.secondary_color = color;
  },
  [types.SET_DEFAULT_LANGUAGE](state, { language }) {
    state.survey.default_lang = language;
  },
  [types.SET_MULTI_LANGUAGE](state, { languages }) {
    state.survey.lang = languages;
  },
  [types.CLEAR_SURVEY_ITEMS](state) {
    state.survey.items = [];
  },
  [types.REMOVE_SURVEY_ITEM]: (state, index) => {
    state.survey.items.splice(index, 1);
  },
  [types.CLEAR_DELETED_ITEMS]: (state) => {
    state.deletedItems = [];
  },
  [types.ADD_DELETED_ITEMS]: (state, uuid) => {
    state.deletedItems.push(uuid);
  },
  [types.TOGGLE_JUMP_LOGIC](state, { value }) {
    state.survey.jump_rules_enabled = value;
  },
  createSurvey: (state, survey) => {
    state.survey = survey;
  },
  updateSurvey: (state, survey) => {
    if (survey.items && survey.items.length === 0) {
      state.survey.items = [];
    }
    survey.items.forEach((item, index) => {
      Object.assign(state.survey.items[index], item);
    });
    state.survey.uuid = survey.uuid;
    state.survey.channel = survey.channel;
    state.survey.cooldown = survey.cooldown;
    state.survey.name = survey.name;
    state.survey.primary_color = survey.primary_color;
    state.survey.secondary_color = survey.secondary_color;
    state.survey.teams = survey.teams;
    state.survey.zendesk_integration_uuid = survey.zendesk_integration_uuid;
    // Object.assign(state.survey, survey)
  },
  removeSurveyItem: (state, index) => {
    state.survey.items.splice(index, 1);
  },
  userTeamsSuccess: (state, userTeams) => {
    state.userTeams = userTeams;
  },
  teamsDataSuccess: (state, { userTeams }) => {
    state.userTeams = userTeams;
  },

  clearPermissions: (state) => {
    state.teamsPermission = [];
    state.categories = [];
  },
  [types.TOGGLE_ITEM_JUMP_LOGIC](state, { index, value }) {
    const item = state.survey.items[index];

    item.jump_rules_enabled = value;

    if (value && item.type === QUESTION_TYPE.MULTIPLE_CHOICE) {
      item.options.forEach((option, optionIndex) => {
        Vue.set(state.survey.items[index].options[optionIndex], 'jump_rules', {
          action: JUMP_ACTIONS.NEXT_QUESTION,
          value: null,
        });
      });
      if (item.option_other) {
        Vue.set(state.survey.items[index], 'other_options_jump_rules', {
          action: JUMP_ACTIONS.NEXT_QUESTION,
          value: null,
        });
      }
    }
  },
  [types.SET_JUMP_LOGIC_ACTION]: (state, { index, path, value }) => {
    const item = state.survey.items[index];

    if (item.type === QUESTION_TYPE.MULTIPLE_CHOICE) {
      item.options[path].jump_rules.action = value;
    } else {
      item.jump_rules[path].action = value;
    }
  },
  [types.SET_JUMP_LOGIC_VALUE]: (state, { index, path, value }) => {
    const item = state.survey.items[index];

    if (item.type === QUESTION_TYPE.MULTIPLE_CHOICE) {
      item.options[path].jump_rules.value = value;
    } else {
      item.jump_rules[path].value = value;
    }
  },
  [types.SET_JUMP_LOGIC_OTHER_OPTION_ACTION]: (state, { index, value }) => {
    state.survey.items[index].other_options_jump_rules.action = value;
  },
  [types.SET_JUMP_LOGIC_OTHER_OPTION_VALUE]: (state, { index, value }) => {
    state.survey.items[index].other_options_jump_rules.value = value;
  },
  [types.RESET_ITEM_JUMP_LOGIC](state, { index }) {
    Object.keys(JUMP_LOGIC_PATHS).forEach((path) => {
      state.survey.items[index].jump_rules[JUMP_LOGIC_PATHS[path]].action = JUMP_ACTIONS.NEXT_QUESTION;
      state.survey.items[index].jump_rules[JUMP_LOGIC_PATHS[path]].value = null;
    });
  },
  [types.SET_COOLDOWN_DISTRIBUTION](state, { cooldown }) {
    state.survey.cooldown_distribution = cooldown;
  },
  [types.SET_COOLDOWN_RESPONSES](state, { cooldown }) {
    state.survey.cooldown_responses = cooldown;
  },
  [types.SET_SURVEY_ITEM_COMPOSITE_ENABLE_DETRACTOR](state, { enable, index, itemIndex }) {
    state.survey.items[index].items[itemIndex].detractor_enabled = enable;
  },
  [types.SET_SURVEY_ITEM_COMPOSITE_ENABLE_DETRACTOR_CHILDREN](state, {
    enable, index, parentIndex, itemIndex,
  }) {
    state.survey.items[index].items[parentIndex].items[itemIndex].detractor_enabled = enable;
  },
  [types.SET_SURVEY_ITEM_COMPOSITE_ENABLE_NEUTRAL](state, { enable, index, itemIndex }) {
    state.survey.items[index].items[itemIndex].neutral_enabled = enable;
  },
  [types.SET_SURVEY_ITEM_COMPOSITE_ENABLE_NEUTRAL_CHILDREN](state, {
    enable, index, parentIndex, itemIndex,
  }) {
    state.survey.items[index].items[parentIndex].items[itemIndex].neutral_enabled = enable;
  },
  [types.SET_SURVEY_ITEM_COMPOSITE_ENABLE_PROMOTER](state, { enable, index, itemIndex }) {
    state.survey.items[index].items[itemIndex].promoter_enabled = enable;
  },
  [types.SET_SURVEY_ITEM_COMPOSITE_ENABLE_PROMOTER_CHILDREN](state, {
    enable, index, parentIndex, itemIndex,
  }) {
    state.survey.items[index].items[parentIndex].items[itemIndex].promoter_enabled = enable;
  },
  [types.SET_CHANNEL](state, { channel }) {
    state.survey.channel = channel;
  },
  [types.SET_WEIGHT](state, { weight, index }) {
    state.survey.items[index].weight = weight;
  },
  [types.SET_REPORT](state, { report }) {
    state.report = report;
  },
  [types.CLEAR_REPORT](state) {
    state.report = {};
  },
};
